module.exports = __webpack_public_path__ + "static/media/ชวด.65f3d7fb.png";